import apiClient from "services/apiClient";

async function addReport(data: any) {
  const url = `/admin/reports`;

  const res = await apiClient.post(url, data);

  return res.data;
}

export default addReport;
